// Based on Gtag.js implementation
// https://developers.google.com/analytics/devguides/collection/gtagjs/

const gaTagTracking = (data: object): void => {
  if (typeof window === 'undefined') {
    return
  }
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(data)
}

export default gaTagTracking
